var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPpe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/ppe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/ppe",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7499553,12.7500149 L20.7499553,15.2500089 L3.24999702,15.2500089 L3.24999702,12.7500149 C3.24999702,9.61525675 5.17500311,6.93284432 7.90586208,5.81174562 L9.49998212,9.00002384 L9.49998212,4.62503427 C9.49998212,4.28003387 9.77998023,4.00003576 10.1249806,4.00003576 L13.8749717,4.00003576 C14.2199721,4.00003576 14.4999702,4.28003387 14.4999702,4.62503427 L14.4999702,9.00002384 L16.0940902,5.81174562 C18.8249492,6.93284432 20.7499553,9.61525675 20.7499553,12.7500149 Z M21.3749538,16.500006 C21.7199542,16.500006 21.9999523,16.7800041 21.9999523,17.1250045 L21.9999523,18.3750015 C21.9999523,18.7200019 21.7199542,19.000006 21.3749538,19.000006 L2.62499851,19.000006 C2.27999811,19.000006 2,18.7200019 2,18.3750015 L2,17.1250045 C2,16.7800041 2.27999811,16.500006 2.62499851,16.500006 L21.3749538,16.500006 Z",
    id: "helmet",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpe);
export default __webpack_public_path__ + "static/media/ppe.7ad0935f.svg";
export { ForwardRef as ReactComponent };